import { Link } from "react-router-dom";

import { LeadActions } from "@/components/LeadActions";
import { SectionHeading } from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";
import { contactDetails } from "@/data/siteContent";

export default function ProductsPage({ content }) {
  const isHindi = content.locale === "hi";
  const featuredProducts = Array.isArray(content?.featuredProducts) ? content.featuredProducts : [];

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <SectionHeading eyebrow={isHindi ? "उत्पाद" : "Products"} title={content.productsPage.title} description={content.productsPage.description} />
      <div className="mt-10 grid gap-6 lg:grid-cols-3 xl:grid-cols-4">
        {featuredProducts.map((product) => (
          <Card key={product.slug} className="flex h-full flex-col overflow-hidden rounded-[30px] border-stone-200 bg-white shadow-sm transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-xl">
            <img src={product.image} alt={product.title} className="aspect-[4/3] w-full object-cover object-center" data-testid={`products-page-image-${product.slug}`} />
            <CardContent className="flex flex-1 flex-col space-y-4 p-6">
              <h2 className="font-heading text-2xl font-semibold text-stone-900" data-testid={`products-page-title-${product.slug}`}>
                {product.title}
              </h2>
              <p className="text-sm leading-7 text-stone-600" data-testid={`products-page-description-${product.slug}`}>
                {product.summary}
              </p>
              {product.slug === "value-added-products" ? (
                <a href="/contact#quote-request" className="mt-auto inline-flex text-sm font-semibold text-primary" data-testid="products-page-coming-soon-link">
                  {content.ctas.requestQuote}
                </a>
              ) : (
                <Link to={`/products/${product.slug}`} className="mt-auto inline-flex text-sm font-semibold text-primary" data-testid={`products-page-link-${product.slug}`}>
                  {content.ctas.visitProduct}
                </Link>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
      <LeadActions labels={content.ctas} contact={contactDetails} prefix="products-page" className="mt-10" />
    </div>
  );
}